import React, { useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Switch from "@material-ui/core/Switch";
import NotificationsOffIcon from "@material-ui/icons/NotificationsOff";

import api from "../../services/api";
import { i18n } from "../../translate/i18n.js";
import toastError from "../../errors/toastError";
import { fmtDate } from "../../translate/localeHelper";

// feat_420 (CK51) — ficha del contacto en el chat: "No molestar".
// Activado = no recibe mensajes de campañas / planilla (Carga de Datos).
// La IA y los asesores le siguen respondiendo si escribe.
// Lo puede activar/desactivar cualquier usuario de la empresa; la IA solo lo
// activa (cuando el contacto lo pide). Si el contacto no trae la propiedad
// (backend anterior) no se muestra nada.
const statusText = (c) => {
  if (!c?.doNotDisturb) return i18n.t("doNotDisturb.contactOffHelp");
  const date = c.doNotDisturbAt ? fmtDate(new Date(c.doNotDisturbAt)) : "";
  if (c.doNotDisturbSource === "ai") {
    const reasonKey = c.doNotDisturbReason === "vehiculo_vendido" ? "reasonVehicleSold" : "reasonAsked";
    return i18n.t("doNotDisturb.byAi", { date, reason: i18n.t(`doNotDisturb.${reasonKey}`) });
  }
  return i18n.t("doNotDisturb.byUser", { date });
};

const DoNotDisturbContactRow = ({ contact }) => {
  const [local, setLocal] = useState(contact);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLocal(contact);
  }, [contact]);

  if (!contact || !Object.prototype.hasOwnProperty.call(contact, "doNotDisturb")) return null;

  const handleToggle = async (e) => {
    const enabled = e.target.checked;
    const prev = local;
    setLocal({ ...(local || {}), doNotDisturb: enabled, doNotDisturbSource: "user", doNotDisturbAt: new Date().toISOString() });
    setSaving(true);
    try {
      const { data } = await api.put(`/contacts/${contact.id}/do-not-disturb`, { enabled });
      if (data?.contact) setLocal(data.contact);
    } catch (err) {
      setLocal(prev);
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  const on = !!local?.doNotDisturb;

  return (
    <Paper square variant="outlined" style={{ padding: "8px 16px", marginTop: 8 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
        <div style={{ minWidth: 0, display: "flex", alignItems: "flex-start", gap: 8 }}>
          <NotificationsOffIcon fontSize="small" style={{ color: on ? "#d32f2f" : "#9e9e9e", marginTop: 2 }} />
          <div style={{ minWidth: 0 }}>
            <label htmlFor="contact-do-not-disturb">
              <Typography variant="subtitle2">{i18n.t("doNotDisturb.contactTitle")}</Typography>
            </label>
            <Typography variant="caption" color="textSecondary" id="contact-do-not-disturb-help">
              {statusText(local)}
            </Typography>
          </div>
        </div>
        <Switch
          id="contact-do-not-disturb"
          checked={on}
          onChange={handleToggle}
          disabled={saving}
          color="primary"
          inputProps={{
            "aria-label": i18n.t("doNotDisturb.contactTitle"),
            "aria-describedby": "contact-do-not-disturb-help"
          }}
        />
      </div>
    </Paper>
  );
};

export default DoNotDisturbContactRow;
